import { useState } from 'react';
import DialogHeader from 'src/components/Dialog/DialogHeader';
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    Grid
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { OtherActionsNextYearModel } from 'src/models/businessManager/businessManager.model';

export default function DialogOtherActionsNextYear(props) {
    const { t } = useTranslation();

    const data: OtherActionsNextYearModel = props.data;
    const handleChange = props.handleChange;
    const openDialogUpdate = props.openDialogUpdate;
    const title = props.title;
    const [errorTextActionType, setErrorTextActionType] = useState<string>("");
    const [errorTextMotivationJustification, setErrorTextMotivationJustification] = useState<string>("");
    const [errorTextImplementationSystems, setErrorTextImplementationSystems] = useState<string>("");

    const handleCloseDialogUpdate = () => {
        setErrorTextActionType('')
        setErrorTextMotivationJustification('')
        setErrorTextImplementationSystems('')

        props.handleCloseDialogUpdate()
    }

    const handleClickUpdate = (e) => {
        e.preventDefault();
        if (data.actionType == '') {
            setErrorTextActionType(t('requiredMessage'));
        } else {
            setErrorTextActionType('')
        }

        if (data.motivationJustification == '') {
            setErrorTextMotivationJustification(t('requiredMessage'));
        } else {
            setErrorTextMotivationJustification('')
        }

        if (data.implementationSystems == '') {
            setErrorTextImplementationSystems(t('requiredMessage'));
        } else {
            setErrorTextImplementationSystems('')
        }

        if (data.actionType != '' && data.actionType != null &&
            data.motivationJustification != '' && data.motivationJustification != null &&
            data.implementationSystems != '' && data.implementationSystems != null) {
            setErrorTextActionType('')
            setErrorTextMotivationJustification('')
            setErrorTextImplementationSystems('')
            props.handleClickUpdate()
        }
    }
    return (
        <>
            <Dialog open={openDialogUpdate} maxWidth={'md'} fullWidth>
                <DialogHeader title={title} />
                <DialogContent style={{ overflowY: "hidden", paddingBottom: 0, paddingTop: 10 }}>
                    <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                        <Grid item xs={4} >
                            <TextField
                                label={t('eepBm.otherActionsNPlus1.title1')}
                                variant="outlined"
                                fullWidth
                                name="actionType"
                                value={data.actionType}
                                onChange={handleChange}
                                error={!!errorTextActionType}
                                helperText={errorTextActionType}
                                multiline
                                maxRows={5}
                                inputProps={{
                                    maxLength: 4094
                                }}
                            />
                        </Grid>
                        <Grid item xs={4} >
                            <TextField
                                label={t('eepBm.otherActionsNPlus1.title2')}
                                variant="outlined"
                                fullWidth
                                name="motivationJustification"
                                value={data.motivationJustification}
                                onChange={handleChange}
                                error={!!errorTextMotivationJustification}
                                helperText={errorTextMotivationJustification}
                                multiline
                                maxRows={5}
                                inputProps={{
                                    maxLength: 4094
                                }}
                            />
                        </Grid>
                        <Grid item xs={4} >
                            <TextField
                                label={t('eepBm.otherActionsNPlus1.title3')}
                                variant="outlined"
                                fullWidth
                                name="implementationSystems"
                                value={data.implementationSystems}
                                onChange={handleChange}
                                error={!!errorTextImplementationSystems}
                                helperText={errorTextImplementationSystems}
                                multiline
                                maxRows={5}
                                inputProps={{
                                    maxLength: 4094
                                }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ justifyContent: "flex-start", paddingLeft: 24, paddingTop: 14, paddingBottom: 16 }}>
                    <Button
                        variant="contained"
                        style={{ marginRight: 5 }}
                        onClick={handleClickUpdate}
                    >
                        <Trans>button.save</Trans>
                    </Button>
                    <Button
                        variant="contained"
                        style={{ marginRight: 10 }}
                        color="error"
                        onClick={handleCloseDialogUpdate}
                    >
                        <Trans>button.cancel</Trans>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
